// Shown on Settings while an SA impersonates. Password and passkey changes go
// straight to Hanko with the SA's OWN session (X-Impersonate-User only reaches
// portal-api), so they would change Dave's account, not the customer's.
// Same pattern as IMPERSONATION_DISMISS_REASON in notices/NoticeBanner.tsx.
export const IMPERSONATION_PASSWORD_REASON =
  'Password changes are disabled while impersonating. The customer can change their own password.';
export const IMPERSONATION_PASSKEYS_REASON =
  'Passkey changes are disabled while impersonating. The customer can manage their own passkeys.';
